import {Component, EventEmitter, Input, Output} from "@angular/core";
import {FontAwesomeService} from "@services/font-awesome.service";

@Component({
  selector: 'app-paginator',
  template: `
    <div class="button-paginate">
      <button mat-button *ngIf="getMax() > 1" (click)="changePage('left')" >
        <fa-icon [icon]="faService.faChevronLeft" class="left-icon"></fa-icon>
      </button>
      <button mat-button *ngFor="let key of paginatePages() ;"
              [class.button-green]="currentPage == key"
              (click)="changePage(key)">{{key}}</button>
      <label *ngIf="getMax() > 10">...</label>
      <button mat-button *ngIf="getMax() > 10" (click)="changePage(getMax())">{{getMax()}}</button>
      <button mat-button *ngIf="getMax() > 1" (click)="changePage('right')">
        <fa-icon [icon]="faService.faChevronRight" class="right-icon"></fa-icon>
      </button>
    </div>
  `,
  styleUrls: ['./paginator.component.scss']
})

export class PaginatorComponent {
  pageIndex = 1;

  @Input() length: any;
  @Input() pageSize: any;
  @Input() currentPage: any;

  @Output() handleChangePage: EventEmitter<number> = new EventEmitter<number>();

  constructor(
    public faService: FontAwesomeService
  ) {}

  getMax() {
    return Math.ceil(this.length / this.pageSize);
  }

  paginatePages() {
    let max = this.getMax();
    if (max > 10) {
      return Array.from({length: 8}, (x, i) => i + 1);
    } else {
      return Array.from({length: max}, (x, i) => i + 1);
    }
  }

  changePage(page) {
    if (page !== 'left' && page !== 'right') {
      this.pageIndex = page;
    }
    if (page === 'left' && this.pageIndex > 1) {
      this.pageIndex = this.pageIndex - 1 ;
    }
    if (page === 'right' && this.pageIndex < this.getMax()) {
      this.pageIndex = this.pageIndex + 1;
    }
    const position = (this.pageIndex - 1) * this.pageSize;
    this.handleChangePage.emit(this.pageIndex);
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/atoms/paginator/paginator.component.ts